@if (formControl && formControl.invalid && (formControl.value || formControl.touched || submitted)) {
  <div class='validation-error'>
    @for (errorType of errorTypes; track errorType) {
      <span>
        {{ validators[errorType](formLabel) }}
      </span>
    }
  </div>
}